import {useState, useEffect, useContext} from 'react'
import Container from '../../../Components/UploadMusic/Container'
import {Helmet} from "react-helmet";
import ValidateUser from '../../../Components/UserCredentials/ValidateUser';
import { GeneralFunctionsContext } from '../../../Components/Contexts/GeneralFunctionsContext';
export default function Uploads () {
    const {innerWidth, offset} = useContext(GeneralFunctionsContext);
    return (
        <>
        
        <Helmet>
            <title>Upload Music</title>
            <meta property="og:title" content="Upload Music" key="1" />
            <meta name="title" content="Upload Music" key="2"/>
            <meta name="description" content="Upload your songs and albums to geniux music." key="3"/>
            <meta property="og:image" content="/assets/images/geniux_music_logo.png" key="4"/>
        </Helmet>
         <Container innerWidth={innerWidth} /> 
         <ValidateUser/>
        </>
    )
}


